"use client";

import cn from "@core/utils/class-names";
import HourGlassIcon from "@core/components/icons/hour-glass";
import TagIcon from "@core/components/icons/tag";
import MetricCard from "@core/components/cards/metric-card";
import { Campaign } from "packages/app/src/types";

export default function CampaignMetricCards({
  className,
  campaigns,
}: {
  className?: string;
  campaigns: Campaign[];
}) {
  const ticketStats = [
    {
      id: 1,
      icon: <HourGlassIcon className="h-full w-[80%]" />,
      title: "All Campaigns",
      metric: campaigns.length,
    },
    {
      id: 2,
      icon: <TagIcon className="h-full w-full" />,
      title: "Active Campaigns",
      metric: "20",
      // link: "/campaign/flagged"
    },
    {
      id: 3,
      icon: <TagIcon className="h-full w-full" />,
      title: "Pending Campaigns",
      metric: "15",
      link: "/campaign/pending",
    },
    {
      id: 4,
      icon: <TagIcon className="h-full w-full" />,
      title: "Flagged Campaigns",
      metric: "6",
      link: "/campaign/flagged",
    },
  ];
  return (
    <div
      className={cn("grid grid-cols-1 gap-5 3xl:gap-8 4xl:gap-9", className)}
    >
      {ticketStats.map((stat) => (
        <MetricCard
          key={stat.title + stat.id}
          title={stat.title}
          metric={stat.metric}
          icon={stat.icon}
          link={stat.link}
          iconClassName="bg-transparent w-11 h-11"
        />
      ))}
    </div>
  );
}
